import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { CoursesService } from 'src/providers/courses.service';
import { DashboardService } from 'src/providers/dashboard.service';
import { VideoGMATDialog } from '../after12/after12.component';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { ThanksDialogueComponent } from '../thanks-dialogue/thanks-dialogue.component';
import { LoginService } from 'src/providers/login.service';
import { VideoPlayerDialog } from '../home/home.component';
import { JSONIDService } from 'src/providers/schema';
import { Config } from '../components/faqs/faqs.component';
import { DeviceDetectorService } from 'ngx-device-detector';

export interface PeriodicElement {
  exam: string;
  ApplicationDates: string;
  ExamDate: string;
  Syllabus: string;
  OfficialWebsite: string;
  syllbusLink:string
}

const ELEMENT_DATA: PeriodicElement[] = [
  { exam: 'CUET UG 2025', ApplicationDates: 'Feb - March , 2025',  ExamDate: '',Syllabus:'https://exams.nta.ac.in/CUET-UG/', OfficialWebsite: 'https://exams.nta.ac.in/CUET-UG/', syllbusLink: 'CUET UG' },
  { exam: 'CUET PG 2025', ApplicationDates: '',  ExamDate: '',Syllabus:'https://pgcuet.samarth.ac.in/', OfficialWebsite: 'https://pgcuet.samarth.ac.in/', syllbusLink:'CUET PG' },
];

@Component({
  selector: 'app-cuet',
  templateUrl: './cuet.component.html',
  styleUrls: ['./cuet.component.scss']
})

export class CuetComponent implements OnInit {

  featuresTab: any = 'dual'

  featuresTabChange(val: any) {
    this.featuresTab = val;
  }

  config!: Config;
  options: Config = { multi: false };
  thumbnail: any[] =[
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/paclhsmbdyi-hd-66d95294853cb.webp', video: 'paCLHSMBDYI',  },
  ]


  faqList:any[] = [
    {
      name: 'What are the key features of iQuanta CUET online courses?',
      iconClass: 'fa fa-code',
      active: true,
      submenu: [
        { answer: 'iQuanta offers 150+ questions per section, 24/7 doubt solving, and 1:1 live lectures to maximise the candidate’s results.', subanswers: [] },
      ]
    },
    {
      name: 'What are the benefits of iQuanta CUET courses? ',
      iconClass: 'fa fa-mobile',
      active: false,
      submenu: [
        { answer: 'You can learn from the best educators available and live and recorded lectures which are easily accessible anytime anywhere. ', subanswers: [] },
      ]
    },
    {
      name: 'How does the iQuanta CUET online course Mock Tests Analysis work?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'iQuanta’s mock test analysis shows your area of improvement in each section such as logical reasoning, legal aptitude or general knowledge.', subanswers: [] },
      ]
    },
    {
      name: 'What is CUET?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: "CUET (Common Undergrad Entrance Test) is a critical examination to get into some of the prestigious undergrad colleges in India.", subanswers: [] },
      ]
    },
    {
      name: 'What are the common mistakes to avoid while preparing?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'Always try to complete your entire syllabus, appear for mock tests and try time management also don’t solely depend on coaching and go for self-preparation.', subanswers: [] },
      ]
    },
    {
      name: 'Is CUET online coaching worth it?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'Yes CUET online coaching is worth it because candidates can save time and money and easily access online coaching from anywhere.', subanswers: [] },
      ]
    },
    {
      name: 'Is CUET paper tough?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'The CUET paper can be challenging for some students but regular practice and consistency can bring you meritorious results. ', subanswers: [] },
      ]
    },
    {
      name: 'Are iQuanta CUET online courses affordable?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'Yes, iQuanta believes that quality education is only good when provided at an affordable price. Most of the candidates can easily go for the CUET online coaching by iQuanta. ', subanswers: [] },
      ]
    },
    {
      name: ' How to manage time while preparing?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'Students are advised to give mock tests repeatedly to effectively understand the pattern of the paper which will ultimately help them with their time management.', subanswers: [] },
      ]
    },
    {
      name: 'What can I expect from CUET online coaching iQuanta?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'iQuanta CUET Online coaching tries to cover each section effectively so that the students can bring the best results and get into their desired undergrad institutions.', subanswers: [] },
      ]
    },
   
  ];


  toppersImg: any[] = [
    'https://www.iquanta.in/blog/wp-content/uploads/2024/09/topper-feeback-1-66d975c78c760.webp',
    'https://www.iquanta.in/blog/wp-content/uploads/2024/09/topper-feeback-2-66d975c6e9003.webp',
    'https://www.iquanta.in/blog/wp-content/uploads/2024/09/topper-feeback-3-66d975c495eb0.webp',
    'https://www.iquanta.in/blog/wp-content/uploads/2024/09/topper-feeback-4-66d975c3bfce5.webp',
    'https://www.iquanta.in/blog/wp-content/uploads/2024/09/topper-feeback-5-66d975c1e87f2.webp',
    'https://www.iquanta.in/blog/wp-content/uploads/2024/09/topper-feeback-6-66d975bd47f25.webp',
    'https://www.iquanta.in/blog/wp-content/uploads/2024/09/topper-feeback-7-66d975bd413f0.webp',
    'https://www.iquanta.in/blog/wp-content/uploads/2024/09/topper-feeback-8-66d975b9e1fbd.webp',
    'https://www.iquanta.in/blog/wp-content/uploads/2024/09/topper-feeback-9-66d975b9d696c.webp',
    'https://www.iquanta.in/blog/wp-content/uploads/2024/09/topper-feeback-10-66d975b68c5a9.webp',
    'https://www.iquanta.in/blog/wp-content/uploads/2024/09/topper-feeback-11-66d975b67cfb9.webp',
    'https://www.iquanta.in/blog/wp-content/uploads/2024/09/topper-feeback-12-66d975b3ae0ce.webp',
    'https://www.iquanta.in/blog/wp-content/uploads/2024/09/topper-feeback-13-66d975b3b33c4.webp',
    
  ]
  
  bschoolsInfo = [
    {
      bschoolName: 'Delhi University',
      summer_placement: 'NA',
      final_palcement: '10+ LPA',
      image: 'https://media.iquanta.in/ui_images/cuet/collages/delhi-university-1200.jpg',
      id: '01',
      link: ''
    },
    {
      bschoolName: 'BHU',
      summer_placement: 'NA',
      final_palcement: '7.4 LPA',
      image: 'https://media.iquanta.in/ui_images/cuet/collages/BHU.jpg',
      id: '02',
      link: ''
    },
    {
      bschoolName: 'University of Allahabad',
      summer_placement: 'NA',
      final_palcement: '7.4 LPA',
      image: 'https://media.iquanta.in/ui_images/cuet/collages/University of allahabad.png',
      id: '03',
      link: ''
    },
    {
      bschoolName: 'Jamia Milia Islamia',
      summer_placement: 'NA',
      final_palcement: '7.4 LPA',
      image: 'https://media.iquanta.in/ui_images/cuet/collages/Jamia Milia Islamia.jpg',
      id: '04',
      link: ''
    },
    {
      bschoolName: 'JNU Delhi',
      summer_placement: 'NA',
      final_palcement: '6 LPA',
      image: 'https://media.iquanta.in/ui_images/cuet/collages/Jawahar lala Nehru University.jpg',
      id: '05',
      link: ''
    },
    {
      bschoolName: 'AMU Aligarh',
      summer_placement: 'NA',
      final_palcement: ' 4 LPA',
      image: 'https://media.iquanta.in/ui_images/cuet/collages/Aligarh Muslim University.jpg',
      id: '06',
      link: ''
    },
    {
      bschoolName: 'BBAU Lucknow',
      summer_placement: 'NA',
      final_palcement: ' 4 LPA',
      image: 'https://media.iquanta.in/ui_images/cuet/collages/BBAU Lucknow.jpeg',
      id: '07',
      link: ''
    },
    {
      bschoolName: 'Dr. BR Ambedkar University Delhi',
      summer_placement: 'NA',
      final_palcement: '4 LPA',
      image: 'https://media.iquanta.in/ui_images/cuet/collages/Dr. BR Ambedkar University Delhi.jpg',
      id: '08',
      link: ''
    },
    {
      bschoolName: 'GGSIPU',
      summer_placement: 'NA',
      final_palcement: '5+ LPA',
      image: 'https://media.iquanta.in/ui_images/cuet/collages/GGSIPU.jpeg',
      id: '09',
      link: ''
    },
    {
      bschoolName: 'LPU Punjab',
      summer_placement: 'NA',
      final_palcement: '8+ LPA',
      image: 'https://media.iquanta.in/ui_images/cuet/collages/Lovely Professional Uniuversity.jpg',
      id: '10',
      link: ''
    },
    

  ]

  slideVal!: number;
  constructor(
    public coursesService: CoursesService, 
    public dialog: MatDialog, 
    private titleService: Title, 
    private metaService: Meta, 
    @Inject(DOCUMENT) private dom: any, 
    @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public router: Router,
    public loginService: LoginService,
    public mockService: JSONIDService) { }

  displayedColumns: string[] = ['exam', 'ApplicationStarts', 'ApplicationEnds', 'ExamDate', 'OfficialWebsite', ];
  dataSource = ELEMENT_DATA;  
  coursesArray: any[] = [];

  gotocourses(){
    var elemnt: any = document.getElementById('course')
    elemnt.scrollIntoView({ behavior: "smooth" })
  }


  json1:any;
  json2:any;
  ngOnInit() {
    this.config = this.mergeConfig(this.options); 
    this.json1 = this.mockService.CUETUG;
    this.json2 = this.mockService.CuetProduct;
    this.getCourses();
    this.selectedReview = this.reviews[0]
 // Meta Data
 this.titleService.setTitle("CUET Course 2026 | CUET Online Coaching");
 this.metaService.updateTag(
 { name: 'description', content: "Enroll in the best CUET online coaching in India with iQuanta. Get expert guidance and comprehensive study materials for the CUET Course 2026 to ensure your success in the CUET exam." }); 
 this.metaService.updateTag( 
 { name: 'keywords', content: 'cuet coaching,cuet 2026,cuet online coaching,cuet course,cuet coaching online,best cuet online coaching,cuet classes,cuet online classes,cuet preparation,cuet online course' });
// Canonical Link
 const head = this.dom.getElementsByTagName('head')[0];
 var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
 head.appendChild(element);
 element.setAttribute('rel', 'canonical')
 element.setAttribute('href', 'https://www.iquanta.in/cuet')
// Facebook
 this.metaService.updateTag(
   { property: 'og:type', content: "website" })
 this.metaService.updateTag(
   { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
 this.metaService.updateTag(
   { property: 'og:title', content: "CUET Course 2026 | CUET Online Coaching" })
 this.metaService.updateTag(
   { property: 'og:url', content: 'https://www.iquanta.in/cuet' })
 this.metaService.updateTag(
   { property: 'og:description', content: "Enroll in the best CUET online coaching in India with iQuanta. Get expert guidance and comprehensive study materials for the CUET Course 2026 to ensure your success in the CUET exam." });
 this.metaService.updateTag(
   { property: 'og:image:height', content: '720' })
 this.metaService.updateTag(
   { property: 'og:image:width', content: '1280' })
 this.metaService.updateTag(
   { property: 'og:image:type', content: 'image/webp' })
 this.metaService.updateTag(
   { property: 'og:image', content: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/cuet-online-coaching.webp' })
// Article Publish Time
 this.metaService.updateTag(
   { property: 'article:published_time', content: '2023-01-23T10:48:33+00:00' })
 this.metaService.updateTag(
   { property: 'article:modified_time', content: '2025-05-12T11:10:42+00:00' })
// Twitter
 this.metaService.updateTag(
   { property: 'twitter:label2', content: "Est. reading time" })
 this.metaService.updateTag(
   { property: 'twitter:data2', content: "9 Minutes" })
 this.metaService.updateTag(
   { property: 'twitter:title', content: "CUET Course 2026 | CUET Online Coaching" })
 this.metaService.updateTag(
   { property: 'twitter:url', content: 'https://www.iquanta.in/cuet' })
 this.metaService.updateTag(
   { property: 'twitter:description', content: "Enroll in the best CUET online coaching in India with iQuanta. Get expert guidance and comprehensive study materials for the CUET Course 2026 to ensure your success in the CUET exam." });
 this.metaService.updateTag(
   { property: 'twitter:image', content: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/cuet-online-coaching.webp' })
 this.metaService.updateTag(
   { property: 'twitter:image:height', content: '720' })
 this.metaService.updateTag(
   { property: 'twitter:image:type', content: 'image/webp' })
 this.metaService.updateTag(
   { property: 'twitter:image:width', content: '1280' })
  }

  ngAfterViewInit(){
    this.getScrollData()
  }




  playVideo(obj: any) {
    const dialogref = this.dialog.open(VideoPlayerDialog, {
      width: '800px',
      data: { video: 'https://www.youtube.com/embed/' + obj.video + '?rel=0', type: 'toppers' },
      panelClass: ['video-dialog', 'video-dilogue2']
    })
    dialogref.afterClosed().subscribe(result => {

    })
  }





  getScrollData(){
    this.loginService.cuetData.subscribe(res=>{
      if(res){
        setTimeout(()=>{
          var elemnt: any = document.getElementById('results-sec')
          elemnt.scrollIntoView({ behavior: "smooth" })
        }, 1000)
      }
    })
  }

  openBlog(val: any) {
    window.open(val, '_blank')
  }
  
  goToSection(val: any) {
    var elemnt: any = document.getElementById(val)
    elemnt.scrollIntoView({ behavior: "smooth" })
  
  }

  enquiryForm1() {
    const dialog = this.dialog.open(FormDialogCuet, {
      width: '390px',
      panelClass: ['enquiry-modal', 'new-enquiry']
    })

    dialog.afterClosed().subscribe(result => {
      if (result.success) {
        const dialogRef = this.dialog.open(ThanksDialogueComponent, {
          width: '330px',
          panelClass: 'thanks-modal'

        })
        dialogRef.afterClosed().subscribe(res => {

        })
       
      }
    })
  }

  mergeConfig(options: Config) {
    // 기본 옵션
    const config = {
      // selector: '#accordion',
      multi: true
    };

    return { ...config, ...options };
  }


  toggle(index: number) {
    if (!this.config.multi) {
      this.faqList.filter(
        (menu, i) => i !== index && menu.active
      ).forEach(menu => menu.active = !menu.active);
    }

    this.faqList[index].active = !this.faqList[index].active;
  }

  joinwhatsapp(){
    window.open('https://chat.whatsapp.com/H8C5grmDvvgLxI98aGYAvk', '_blank')
  }


  playvideo(video:any) {

    const dialog = this.dialog.open(VideoGMATDialog, {
      width: '810px',
      panelClass: 'videoGmat',
      data: video
    })
  }
  subscribechannel() {
    window.open('https://www.youtube.com/channel/UCluniE65oSuRxbHPKKbXQsA?sub_confirmation=1', '_blank')
  }

  courseDetails:any;
  buynow(courseObj: any) {
    let courseId = courseObj.id;
    this.coursesService.courseDetails(courseId).subscribe(res => {
      if (res.length > 0) {
        this.courseDetails = res[0];
        this.sessionStorage.setItem('cartArray', JSON.stringify(this.courseDetails))
        this.router.navigate(['cart'])
      }
    })
  }

  details(courseObj: any) {
    window.open(courseObj.course_link, '_self')
  }
  gotocourse() {
    var elemnt:any = document.getElementById("courses-div")
    elemnt.scrollIntoView()
  }

  gotoLink(obj: any) {

    if (obj.link) {
      window.open(obj.link, '_blank')
    }

  }

  public scrolling = false;
  private timeout: any;

  @HostListener('window:scroll', ['$event'])
  onScroll(event:any) {
    this.scrolling = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.scrolling = false;
    }, 200);
  }

  
  index1 = 0;
  next_slide1() {
    let index = this.index1;

    const prev: any = document.querySelector(".prev1");
    const next: any = document.querySelector(".next1");
    const carousel: any = document.querySelector(".carousel-container1");
    const track: any = document.querySelector(".track1");
    let width = carousel.offsetWidth;
   
    if (index < 2) {
      index = index + 1;
      prev.classList.add("show");
      track.style.transform = "translateX(" + index * -width + "px)";
    }

    // if (track.offsetWidth - index * width < index * width) {
    //   next.classList.add("hide");
    // }
    if (index == 1) {
      next.classList.add("hide");
      prev.classList.remove("hide");
    }
    // }
    this.index1 = index;
  }

  previous_slide1() {
    let index = this.index1;
    const prev: any = document.querySelector(".prev1");
    const next: any = document.querySelector(".next1");
    const carousel: any = document.querySelector(".carousel-container1");
    const track: any = document.querySelector(".track1");
    let width = carousel.offsetWidth;
    if (index > 0) {
      index = index - 1;
      next.classList.remove("hide");
      track.style.transform = "translateX(" + index * -width + "px)";

    }

    if (index === 0) {
      prev.classList.add("hide");
    }
    this.index1 = index
  }
  getCourses() {
    this.coursesArray = []
    this.coursesService.getPagewiseCourses('CUET', 'landingpage', '2023').subscribe(res=>{
      if (res.success) {
        if(res.data.length > 0){
        this.coursesArray = res.data[0].course.filter((x:any)=> !x.is_rq);
       this.coursesArray.sort((a:any, b:any) => a.course_name > b.course_name ? 1 : -1)
        }
      }
    })

  }

  fbLink() {
    
      window.open('https://www.facebook.com/groups/cuetprep', '_blank')
  }

  whatsappLink() {
   
      window.open('https://chat.whatsapp.com/H8C5grmDvvgLxI98aGYAvk ', '_blank')
    
  }

  youtubeLink() {
   
      window.open('https://www.youtube.com/@cuetpreparation-iquanta9397 ', '_blank')
  }

  instaLink(){
     window.open('https://www.instagram.com/cuet_updates/','_blank')
  }

  joinnow() {
    window.open('https://www.facebook.com/groups/1032678260678641', '_blank')
  }

  selectedReview: any;

  changeReview(reviewObj:any) {
    this.selectedReview = reviewObj;
  }





  cardList:any[]=[
    {
      image:'https://www.iquanta.in/blog/wp-content/uploads/2022/05/ef8fd540-571a-48f5-9c63-6aeb21a0b6e7-1068x601.jpg',
      title:'CUET Syllabus & Pattern',
      link:'https://www.iquanta.in/blog/cuet-syllabus/'
    },
    {
      image:'https://www.iquanta.in/blog/wp-content/uploads/2022/05/IMG-20220519-WA0014-1068x601.jpg',
      title:'CUET : Science Syllabus & Pattern',
      link:'https://www.iquanta.in/blog/cuet-for-science/'
    },
    {
      image:'https://www.iquanta.in/blog/wp-content/uploads/2022/05/IMG-20220519-WA0012-1068x601.jpg',
      title:'CUET : Commerce Syllabus & Pattern',
      link:'https://www.iquanta.in/blog/cuet-for-commerce/'
    },
    {
      image:'https://www.iquanta.in/blog/wp-content/uploads/2022/05/IMG-20220519-WA0015-1068x601.jpg',
      title:'CUET : Arts / Humanities Syllabus & Pattern',
      link:'https://www.iquanta.in/blog/cuet-for-arts/'
    },
    {
      image:'https://www.iquanta.in/blog/wp-content/uploads/2022/05/197fa477-e87a-4c1a-af9f-f04978dd559e-1068x601.jpg',
      title:'CUET : Step By Step Admission Process to Each Course in DU ',
      link:'https://www.iquanta.in/blog/step-by-step-admission-process-to-each-course-in-du/'
    }, {
      image:'https://www.iquanta.in/blog/wp-content/uploads/2022/06/e6787ba1-3efa-4142-95d1-0d2fe98c6632-1068x601.jpg',
      title:'CUET 2022 Preparation Strategy | How to Prepare for CUET Exam',
      link:'https://www.iquanta.in/blog/cuet-2022-preparation-strategy-how-to-prepare-for-cuet-exam/'
    }
  ]
  

  reviews:any[] = [
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/devyani-66d9835126dcb.webp', title: 'Devyani Mengi',
      percentage: 'Political Science-100 | Psychology-100 | English-98.09 | Economics-97.9',
      text: 'I would like to acknowledge your efforts and hardwork that helps me score good in CUET exam.',
      long_description: 'Dear IQuanta, I would like to acknowledge your efforts and hardwork that helps me score good in CUET exam. I am very happy that my family and my decision of choosing IQuanta as a study platform to prepare for CUET exam was right. I am happy with my score in the exam. I would like to extend my gratitude towards teachers who helped me in preparing and solving all my doubts. At the end,  I would like to say that IQuanta is the perfect place to prepare for competitive exams. Thank you'
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/shivansh-66d9834fee778.webp', title: 'Shivansh Tiwari',
      percentage: 'English - 100 percentile',
      text: 'I completely relied on the study material, questionnaires & mocks provided by iQuanta.',
      long_description: 'I completely relied on the study material, questionnaires & mocks provided by iQuanta. It helped me perform excellent in English & General test. Faculties were very friendly and supportive to clarify doubts whenever needed. I extend my sincere thanks.'
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/muskan-66d9834edbcae.webp', title: 'Muskan',
      percentage: 'English - 97.68 Percentile',
      text: 'Mock tests by iQuanta helped me manage time and formulate a strategy to crack the exam.',
      long_description: 'Mock tests by iQuanta helped me manage time and formulate a strategy to crack the exam. I recommend mocks to everyone as they are available as sectionals as well as assignments. I am thankful to the faculties who were always motivating us to perform better and better.'
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/jyoti-66d9834fe525b.webp', title: 'Jyoti Garg',
      percentage: 'English - 95.26 ',
      text: 'The study material was relevant and concise. Mocks helped me to improve upon ',
      long_description: 'The study material was relevant and concise. Mocks helped me to improve upon my mistakes and not commit the same in the actual exam. Joining iQuanta was indeed the best decision towards cracking CUET.'
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/sunitha-66d9834dc7ec9.webp', title: 'Sunita Chitale',
      percentage: 'Accountancy - 95+ | Business Studies - 95+ | Economics - 96+',
      text: 'I Can safely say that one should choose iQuanta for their CUET Preparation. All my doubts whether academic or non ',
      long_description: 'I Can safely say that one should choose iQuanta for their CUET Preparation. All my doubts whether academic or non academic related to course and colleges were also quickly addressed. Thankyou iQuanta for instilling such a great confidence in me.     '
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/dhruv-66d9834ece926.webp', title: 'Dhruv Sethi',
      percentage: 'English - 99.5 | Mathematics - 98.9 | General Test - 99.5',
      text: 'Right from well curated mocks to extensive doubt clarification, there was nothing that iQuanta left in my journey. ',
      long_description: 'Right from well curated mocks to extensive doubt clarification, there was nothing that iQuanta left in my journey. Faculties personally motivated me at time when I needed it the most. I am bereft of words to thank Faculties and mentors. '
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/divyanshi-66d9834cb9113.webp', title: 'Divyanshi Tevatia',
      percentage: 'Mathematics - 95.47',
      text: 'I don’t know what I would’ve done without iQuanta classes and mocks. All the mentors kept',
      long_description: 'I don’t know what I would’ve done without iQuanta classes and mocks. All the mentors kept me motivated and on top of my content. They always made sure they give their best.'
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/tizil-66d9834dd370e.webp', title: 'Tizil Chaturvedi',
      percentage: 'Accountancy- 96.4 | Business Studies - 97.2',
      text: 'iQuanta facilitated my preparation in every possible way. I recommend everyone to ',
      long_description: 'iQuanta facilitated my preparation in every possible way. I recommend everyone to take the mocks seriously and learn from their mistakes. The same helped me. All the faculties made sure that our bases were clear.'
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/riya-66d9834bd790d.webp', title: 'Riya ',
      percentage: 'English - 97.4',
      text: 'All the video lectures and practice tests were a click away and I never felt that I had to manage board',
      long_description: 'All the video lectures and practice tests were a click away and I never felt that I had to manage board exams alongside CUET. The syllabus and material were to the point and properly curated. I always felt happy to write and mocks and kept making me perform better everyday.'
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/garv-66d9834cb2e36.webp', title: 'Garv Chokhani ',
      percentage: 'English - 97.2 | General test - 99.06',
      text: 'Starting early with iQuanta was the key to my success. I took the exam very seriously as it was being',
      long_description: 'Starting early with iQuanta was the key to my success. I took the exam very seriously as it was being conducted for the first time, I had many doubts and confusions regarding colleges, courses, Study material and all of them were clarified by mentors who were almost 24*7 available.'
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/ritik-66d9834aa7535.webp', title: 'Ritik Anjna',
      percentage: 'English - 99.55 | Accountancy - 94.27',
      text: 'CUET as a completely new exam with new set of rules and regulations made me nervous in the beginning but',
      long_description: 'CUET as a completely new exam with new set of rules and regulations made me nervous in the beginning but that nervousness disappeared in no time after I joined iQuanta and personally talked to the mentors about it. They very patiently explained every question I asked them. I highly recommend iQuanta to every student, especially the average ones like me. '
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/sahil-66d9834bcded1.webp', title: 'Sahil Makker ',
      percentage: 'English - 100 | Economics - 98.67',
      text: 'I could not believe my eyes when I got a 100 percentile in English. I instantly thanked my mentors and teachers',
      long_description: 'I could not believe my eyes when I got a 100 percentile in English. I instantly thanked my mentors and teachers for being fantastic, always approachable. They always pushed me to believe that the target was achievable. I recommend iQuanta Mocks and Test series to every student and properly analyse your mistakes. Thankyou iQuanta for helping me achieve this accolade.'
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/harsh-66d98349a566c.webp', title: 'Harsh Sharma ',
      percentage: 'Business Studies - 99.55 | Economics - 96.7',
      text: 'Mock tests and study material complemented with on time mentorship helped me a lot',
      long_description: 'Mock tests and study material complemented with on time mentorship helped me a lot. I constantly bothered faculties and mentors not only for doubts but for counselling related queries which were very politely addressed. I pay my sincere gratitude to iQuanta. Thankyou.'
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/meera-66d9834a9739f.webp', title: 'Meera',
      percentage: 'Accountancy- 98.7 | General Test- 97.3 | Business Studies- 95',
      text: 'iQuanta classes were the best thing that happened to me. I will undoubtedly recommend',
      long_description: 'iQuanta classes were the best thing that happened to me. I will undoubtedly recommend mocks and classes to everyone who aspires to get into the top colleges. Mentors are very friendly and full of knowledge. I could always watch the recorded classes whenever I missed them which helped me cover up whenever I used to lag behind.Thankyou iQuanta for always encouraging me.'
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/falak-66d98349af7db.webp', title: 'Falak Zehra',
      percentage: 'Accountancy -91 | Economics-91',
      text: 'I was very confused since the very first time I heard of the term CUET. With so many changes and combination',
      long_description: 'I was very confused since the very first time I heard of the term CUET. With so many changes and combination of subjects to choose from, I always feared committing silly mistakes. I don’t remember any instance when I needed the mentors and they were not there. This is a genuine feedback that I am writing here to thank all the faculties genuinely for instilling a strong belief in me.'
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/palak-66d98348d392b.webp', title: 'Palak Pandey',
      percentage: 'Accountacy-98.4 | Business Studies-97.8 | General Test-95.3',
      text: 'I want to thank all the faculties and mentors at iQuanta for curating mocks and tests very close to the actual exam. ',
      long_description: 'I want to thank all the faculties and mentors at iQuanta for curating mocks and tests very close to the actual exam. All the mentors were ever ready to help and motivate me. General Test never felt like a new subject to me since a wide variety of questions were properly covered by faculties. '
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/parul-66d98347dc357.webp', title: 'Parul Singh',
      percentage: 'General Test-98.08 | Business Studies-97.5 | Economics-96.8',
      text: 'I will never be able to thank all the teachers enough for having made test prep so easy.',
      long_description: 'I will never be able to thank all the teachers enough for having made test prep so easy. CUET being the first competitive exam that I was going to write, I wanted to come up with flying colours and I believe I have. My confidence was boosted from my performance in the test series and increasing mock scores.'
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/harshit-66d98348bb74f.webp', title: 'Harshit Aggarwal',
      percentage: 'English - 97.4',
      text: 'I joined iQuanta for my English Language preparation and I am more than happy with my performance. ',
      long_description: 'I joined iQuanta for my English Language preparation and I am more than happy with my performance. This would not have been possible without the constant support of all the faculties who not only taught us but always motivated us as well.'
    },
    {
      img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/darshika-66d98347e95ed.webp', title: 'Darshika Gupta',
      percentage: 'General Test-99.6 | Accountancy-99.06 | Mathematics-96.3',
      text: 'I would like to give credits to iQuanta faculties and mentors for all their support and encouragement.',
      long_description: 'I would like to give credits to iQuanta faculties and mentors for all their support and encouragement. There were ups and downs during the test prep and mock performances but the collective effort from Teachers through the last few crucial months helped me a lot.'
    }

  ]


}


@Component({
  selector: 'app-form',
  templateUrl: './form.html',
  styleUrls: ['./cuet.component.scss']

})
export class FormDialogCuet {
  callBackForm: FormGroup;
  submittedBtn: boolean = false;
  userData:any;
  token:any;
  constructor(public dialogRef: MatDialogRef<FormDialogCuet>, public formBuilder: FormBuilder, @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public matSnackBar: MatSnackBar, public courseService: CoursesService, public dashboardService: DashboardService, public deviceService: DeviceDetectorService,
  @Inject(DOCUMENT) public doc:any) {
    this.callBackForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")])],
      phone: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      course: ['', Validators.required]
    })
    this.token = this.sessionStorage.getItem('usertoken');
    if (this.token) {
      this.userData = JSON.parse(this.sessionStorage.getItem('userData'));

    }
  }

  callback() {
    if (this.callBackForm.valid) {
      this.submittedBtn = true;
      let reqObj = {
        name: this.callBackForm.value.name,
        email: this.callBackForm.value.email,
        phone_no: this.callBackForm.value.phone,
        course_name: this.callBackForm.value.course
      }
      this.courseService.callback(reqObj).subscribe(res => {
        // this.dialogRef.close(res)
        if (res.success) {
          this.addInternalCRMLead()
          this.addNPF()
          this.dialogRef.close(res)
        }
      })
    } else {
      this.matSnackBar.open('Please enter valid Details', 'OK', {
        verticalPosition: 'top',
        duration: 3000,
        panelClass: 'snack-error'
      })
    }

  }

  addInternalCRMLead() {
    // if (this.token) {
      let medium: any;
      let source: any;
      let campaign: any;
      if (this.sessionStorage.getItem('utmLink')) {
        this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
          if (item.includes('utm_medium')) {
            medium = item.split('=')[1]
          }
          if (item.includes('utm_source')) {
            source = item.split('=')[1]
          }
          if (item.includes('utm_campaign')) {
            campaign = item.split('=')[1]
          }
        })
      }
      let reqObj = {
        "orgId": "66dec57ce200bc89284602d6",
        "uid": '66dec57ce200bc89284602d6',
        "userId": this.userData ? this.userData.id : 9999,
        "registrationDate": this.userData ? new Date(this.userData.date_joined).valueOf() : new Date().valueOf(),
        "name": this.callBackForm.value.name,
        "firstName": this.callBackForm.value.name,
        "countryCode": 91,
        "phone": this.callBackForm.value.phone,
        "email": this.callBackForm.value.email,
        "source": "Website",
        "medium": 'CUET',
        "campaign": 'Free Counselling',
        "pageLocation": 'CUET',
        "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.doc.URL,
        "registrationDevice": this.deviceService.deviceType,
        "ipAddress": this.sessionStorage.getItem('ipAddress'),
        "customFields": {
          "exam": this.callBackForm.value.course,
          "examCategory": 'After 12th',
          "examTargetYear": '2025',
        "leadPriority": "Platinum",

        },
        dataSource: [
          {
            utmSource: source,
            utmMedium: medium,
            utmCampaign: campaign,
            utmAdContent: "",
            "pageLocation": this.doc.URL,
            "source": "Website",
            "medium": 'CUET',
            "campaign": 'Free Counselling',
            adContent: "",
    
            browser: this.deviceService.browser,
            browser_version: this.deviceService.browser_version,
            device: this.deviceService.device,
            deviceType: this.deviceService.deviceType,
            orientation: this.deviceService.orientation,
            os: this.deviceService.os,
            os_version: this.deviceService.os_version,
            platformId: this.deviceService['platformId'],
            ua: this.deviceService.ua,
            userAgent: this.deviceService.userAgent,
            "ipAddress": this.sessionStorage.getItem('ipAddress'),
          },
        ],
      }

      this.dashboardService.addCRMLead(reqObj).subscribe(res => {
        if (res.success) {

        }
      })
    // }
  }
  

  addNPF() {
    let reqObj ={
      "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
      "college_id": "5802",
      "name": this.callBackForm.value.name,
      "field_last_name": '',
      "country_dial_code": "+91",
      "mobile": this.callBackForm.value.phone,
      "email": this.callBackForm.value.email,
      "field_gender": '',
      "field_exam_category": this.callBackForm.value.course,
      "field_course_year": '',
      "field_exam":this.callBackForm.value.course,
      "source": "Website",
      "medium": 'CUET',
  "field_lead_priority": 'Gold',
    }

    this.dashboardService.addLeadSquared(reqObj).subscribe(res => {
      this.callBackForm.reset()

    })
  }


  close() {
    this.dialogRef.close()
  }

  
 

}